import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Firm Fit Factory — UI error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          style={{
            minHeight: "60vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            background: "#090909",
            color: "#fff",
            textAlign: "center",
            padding: "40px 20px",
          }}
        >
          <h2 style={{ fontFamily: "Anton, sans-serif", textTransform: "uppercase" }}>
            Something went wrong
          </h2>
          <p style={{ color: "#a6a6a6", maxWidth: "420px" }}>
            This section couldn't load. Please refresh the page or try again shortly.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: "#ff4d00",
              color: "#090909",
              padding: "12px 24px",
              fontWeight: 700,
              borderRadius: "4px",
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
